import { render, staticRenderFns } from "./PlaylistModal.vue?vue&type=template&id=2639c53c&"
import script from "./PlaylistModal.vue?vue&type=script&lang=ts&"
export * from "./PlaylistModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports